// import agent from "../agent";
import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { MUSIC_PLAY, MUSIC_TABLE_UNLOAD, SHOW_SHOP_CAR, CHECK_PRICE_GROUP } from "constants/actionTypes";
import { Pagination } from "antd";
import Loading from "components/Loading";
import MusicTableCell from "components/Music/comps/MusicTableCell";
import FavoriteTableCell from "components/Music/comps/FavoriteTableCell";
import { addCart, addFavorite, rmFavorite, redirectTo, noLoginAddCart, noShowPage } from "dispatch";
import agent from "agent";
import "./page.less";
const queryString = require("query-string");

const mapStateToProps = (state, ownProps) => ({
    ...state.musicTable,
    ...ownProps,
    pagination: ownProps.pagination || state.musicTable.pagination,
    loading:
        typeof ownProps.loading === "boolean"
            ? ownProps.loading
            : state.musicTable.loading,
    tableData:
        typeof ownProps.tableData !== "undefined"
            ? ownProps.tableData
            : state.musicTable.tableData,
    musicPlay: state.player.audio,
    userLogin: state.app.userLogin,
    labels: state.labels.labelsDataAll,
});

const mapDispatchToProps = dispatch => ({
    playMusic: musicPlay => {
        return dispatch({ type: MUSIC_PLAY, musicPlay });
    },
    unLoadTable: () => {
        return dispatch({ type: MUSIC_TABLE_UNLOAD });
    },
    showCarPopup: addAudio => {
        return dispatch({ type: SHOW_SHOP_CAR, addAudio });
    },
    checkPriceGroup: id => {
        return dispatch({
            type: CHECK_PRICE_GROUP,
            payload: agent.PriceGroup.get(id),
        });
    },
});

class MusicTable extends React.Component {
    static propTypes = {
        pagination: PropTypes.object.isRequired,
        loading: PropTypes.bool.isRequired,
        tableData: PropTypes.array,
        musicPlay: PropTypes.object,
        loadData: PropTypes.func.isRequired,
        unLoadTable: PropTypes.func.isRequired,
        playMusic: PropTypes.func.isRequired,
        one: PropTypes.bool,
        location: PropTypes.object.isRequired,
        match: PropTypes.object.isRequired,
        inverted_condition: PropTypes.object,
        one_id: PropTypes.number,
        showCarPopup: PropTypes.func.isRequired,
        checkPriceGroup: PropTypes.func.isRequired,
    };
    componentDidMount() {
        if (!this.props.disableAutoLoad) {
            this.loadCurrentPageData();
        }
    }

    loadCurrentPageData = () => {
        const { loadData, pagination, location, one, inverted_condition, one_id, disableAutoLoad } = this.props;
        if (one) {
            const pager = {
                current: 1,
                pagerSize: 4
            }
            const theSame = {
                sameStyle: inverted_condition.style,
                sameEmotion: inverted_condition.emotion,
                sameScene: inverted_condition.scene,
                sameInstrument: inverted_condition.instrument,
                oneId: one_id,
            }
            const params = {
                page: 1,
                size: 4,
                ...theSame,
            };
            loadData(pager, params);
        } else if (!disableAutoLoad) {
            const pager = { ...pagination };
            pager.current = 1; // default
            const query = queryString.parse(location.search);
            const params = {
                page: pager.current,
                ...query,
                size: pagination.pageSize,
            };
            // reset from params
            pager.current = parseInt(params.page);
            loadData(pager, params);
        }

    };

    componentWillUnmount() {
        this.props.unLoadTable();
    }

    onPageChange(pageNumber) {
        const { loadData, pagination, match, location } = this.props;
        const pager = { ...pagination };
        pager.current = pageNumber;
        const query = queryString.parse(location.search);
        let tiao = noShowPage.baseDecode(query.tiao);
        const params = {
            ...tiao,
            page: pager.current,
        };
        const stringTiao = {
            tiao: noShowPage.baseEecode(params),
        }
        const stringified = queryString.stringify(stringTiao);
        redirectTo({
            pathname: match.url,
            search: `?${stringified}`,
        });
        params.size = pagination.pageSize;
        loadData(pager, params);
    }

    idFavoritePage = () => {
        const { match } = this.props;
        return match.path.indexOf("/favorite") === 0;
    };

    clickFavorite(audio) {
        const { userLogin } = this.props;
        if (!userLogin) {
            // login first
            redirectTo("/login");
            return;
        }
        if (audio.like) {
            let callback = null;
            if (this.idFavoritePage()) {
                // favorite list reload page
                callback = () => {
                    this.loadCurrentPageData();
                };
            }
            rmFavorite(
                { audioid: audio.audioid, like_id: audio.like.id },
                callback
            );
        } else {
            addFavorite({ audioid: audio.audioid });
        }
    }

    handleAddCart(audio) {
        const { userLogin } = this.props;
        if (!userLogin) {
            // login first
            //redirectTo("/login");
            noLoginAddCart(audio);
            return;
        }
        addCart(audio);
    }
    showCarPopup(audio) {
        const { showCarPopup, checkPriceGroup } = this.props;
        const send = {
            showAddCar: true,
            addAudio: audio,
        };
        checkPriceGroup(audio.price_group_id);
        showCarPopup(send);
    }
    renderCell(audio, i) {
        const { musicPlay, playMusic, labels } = this.props;
        audio.playing =
            !!musicPlay && musicPlay.id === audio.id && !!musicPlay.playing;

        const dispatch = {
            labels,
            playMusic,
            clickFavorite: this.clickFavorite.bind(this),
            addCart: this.showCarPopup.bind(this),
        };
        console.log(audio, dispatch)
        if (this.idFavoritePage()) {
            return <FavoriteTableCell key={`cel-${i}`} audio={audio} {...dispatch} />;
        }
        return <MusicTableCell key={i} audio={audio} {...dispatch} />;
    }
    render() {
        const { loading, pagination, labels, tableData: audios, one, emptyText, hidePagination } = this.props;
        const isShow = one ? "resultPagination hidden" : "resultPagination page-left";
        if (!audios) {
            return (
                <div className="resultItemWrapper">
                    <Loading loading={loading} />
                </div>
            );
        }
        if (!labels) {
            return (
                <div className="resultItemWrapper">
                    <Loading loading={loading} />
                </div>
            );
        }
        if (!audios || !audios.length) {
            return (
                <div className="resultItemWrapper text-center">
                    <p>{emptyText || "没有音乐"}</p>
                </div>
            );
        }
        return (
            <div className="resultItemWrapper c02b478-music-table">
                <Loading loading={loading} />
                {audios.map(this.renderCell.bind(this))}
                {!hidePagination && (
                    <div className=" page-ov">
                        {/**搜索页的显示跳十页 */}
                        <div className={isShow} >
                            <Pagination
                                defaultPageSize={pagination.pageSize}
                                {...pagination}
                                defaultCurrent={1}
                                hideOnSinglePage={true}
                                onChange={this.onPageChange.bind(this)}
                                // showTotal={total => `/${Math.ceil(total / 10)} 页`}
                                showQuickJumper
                            />
                        </div>
                    </div>
                )}
                {/* <div className="totlPageClass">/ {Math.ceil(pagination.total / 10)} 页</div> */}
            </div>
        );
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(MusicTable);
